import { useNavigate, useParams } from 'react-router'
import { NavLink } from 'react-router-dom'
import classnames from 'classnames'

import IconDropdown from 'components/IconDropdown'
import { DropDownItem } from 'types/components'
import { useCanUI } from 'hooks/useCanUI'

const Tabs = (): JSX.Element => {
  const navigate = useNavigate()
  const { traderId } = useParams()

  const { memberTabsNavigation, memberMoreTabsNavigation } = useCanUI()

  const MOREOPTIONS: DropDownItem[] = memberMoreTabsNavigation.map((item) => ({
    label: item.route.title,
    value: item.route.pathname || '',
  }))

  return (
    <div className="flex flex-grow">
      <nav className="flex flex-wrap z-1">
        {memberTabsNavigation
          .filter((item) => item.module !== 'More')
          .map((item, index) => (
            <NavLink
              key={'profile-' + index}
              className={({ isActive }) =>
                classnames(
                  'px-3 py-2 text-gray-700 border-primary ',
                  isActive ? 'border-b-2' : null
                )
              }
              // activeClassName="border-b-2"
              to={`/member-profile/${traderId}/${item.route.pathname}`}
            >
              <span className="tracking-wider uppercase font-light">
                {item.route.title}
              </span>
            </NavLink>
          ))}

        {MOREOPTIONS.length ? (
          <div className="px-3 py-2 text-gray-700">
            <IconDropdown
              title={
                <span className="tracking-wider uppercase font-light">
                  + More
                </span>
              }
              options={MOREOPTIONS}
              menuClassName="shadow-md z-10"
              onSelect={(value) => {
                navigate(`/member-profile/${traderId}/${value}`)
              }}
            />
          </div>
        ) : null}
      </nav>
    </div>
  )
}

export default Tabs
